import { ReviewData } from './types';
import { getAppInstance } from '@/utils/api/app';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { getTrustpilotClient } from '@/utils/api/trustpilot';

/**
 * React query key
 *
 * @var {String}
 */
export const queryKey: QueryKey = ['trustpilot', 'reviews'];

/**
 * Get Trustpilot reviews using the client
 *
 * @return  {ReviewData}  Trustpilot review data
 */
const clientTrustpilotReviews = async () => {
  const { data } = await getAppInstance().post<ReviewData>('/trustpilot/reviews');

  return data;
};

/**
 * Get Trustpilot reviews using the server
 *
 * @return  {ReviewData}  Trustpilot review data
 */
export const serverTrustpilotReviews = async () => {
  const { data } = await getTrustpilotClient().get<ReviewData>(`/business-units/4c9328ce00006400050de080/reviews`, {
    params: {
      language: 'en',
      perPage: 15,
      stars: 5,
    },
  });

  return data;
};

/**
 * Trustpilot Reviews Query
 *
 * @return  {UseQueryResult<ReviewData, unknown>}  React Query return type
 */
export function useTrustpilotReviews() {
  return useQuery({
    queryFn: clientTrustpilotReviews,
    queryKey,
  });
}
